import { defaultCountry } from '../../shared-lib/i18n/i18n'
import { geoJsonPoint } from './geo'

export const findAddress = async (addressSearchUrl: string, googlePlacesApiKey: string, searchTerm: string, addressSearchCountry: string) => {
  const findPlaceIdUrl = `${addressSearchUrl}/textsearch/json?key=${googlePlacesApiKey}&query=${searchTerm}&libraries=places&components=${addressSearchCountry}&language=en`

  try {
    const response = await fetch(findPlaceIdUrl)
    const jsonPlaceId = await response.json()

    if (jsonPlaceId.results.length > 0) {
      const { place_id } = jsonPlaceId.results[0]

      const findPlaceUrl = `${addressSearchUrl}/details/json?placeid=${place_id}&key=${googlePlacesApiKey}`
      const response = await fetch(findPlaceUrl, { 'method': 'GET', 'headers': {} })
      const json = await response.json()

      const { address_components, geometry: { location: { lat, lng } } } = json.result

      const addressParts = {
        street_number: '',
        route: '',
        sublocality: '',
        postal_code: '',
        postal_town: '',
      }

      Object.keys(addressParts).forEach(k => {
        const value = address_components.find((component: any) => component.types.includes(k))?.long_name
        if (value) addressParts[k as keyof typeof addressParts] = value
      })

      const addressFromSearch = {
        placeId: place_id,
        lat,
        lng,
        line1: '',
        line2: `${addressParts.street_number} ${addressParts.route}`.trim(),
        region: addressParts.postal_town,
        postalCode: addressParts.postal_code,
        location: geoJsonPoint(lat, lng),
      }

      return addressFromSearch
    }

    return null
  } catch (e) {
    console.info(e)
    return null
  }
}

export const searchConfig: Record<string, string> = {
  [defaultCountry]: 'country:gb|country:gg|country:im|country:je',
}

export const getSearchConfig = (country: string | null | undefined) => searchConfig[country || defaultCountry] || (`country:${country}`).toLowerCase()